import React from 'react'

import { Typography } from '@mui/material'
import { Box } from '@mui/system'

export const TabsTitle = ({ items, value, onChange, containerSx }) => {

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', background: '#F5F9FF', borderRadius: 1, p: 1,whiteSpace:'pre', ...containerSx }}>
           
            {items.map(item => {
                const isItemSelected = value == item.key
                return <Box
                    sx={{ px: { xs: 5, lg: 10 }, py: 1, borderRadius: 1, cursor: 'pointer', flex: { xs: 1, lg: 0 }, textAlign: 'center', backgroundColor: isItemSelected ? '#fff' : 'unset' }}
                    onClick={() => onChange(item.key)}>
                    <Typography
                        fontWeight={700}
                        fontSize={{ xs: 14, lg: 15 }}
                        color={isItemSelected ? '#3F5E84' : '#8EA7C6'}
                    >{item.title}</Typography>
                </Box>
            })}

        </Box>
    )
}
